var api = require("!../../style-loader/dist/runtime/injectStylesIntoLinkTag.js");
            var content = require("!!../../file-loader/dist/cjs.js??ref--8-1!../../postcss-loader/src/index.js??postcss!./billboard.css");

            content = content.__esModule ? content.default : content;

var options = {"injectType":"linkTag","attributes":{"data-remote-style":"ally-next-remote-dashboard"}};

options.insert = "head";

var update = api(content, options);



